import { INIT } from './view'
import {
  addUniqueValueToArray
} from 'utils/redux'

export const NAMESPACE = 'KanBo/Board/archivedCards/'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const SET_CURSOR = NAMESPACE + 'SET_CURSOR'

const defaultBoardState = {
  ids: [],
  isLoading: false,
  isLoaded: false,
  cursor: null,
}

const initialState = {}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        [action.payload.boardId]: {
          ...defaultBoardState,
        }
      }
    case ADD:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          ids: addUniqueValueToArray({
            array: state[action.payload.boardId].ids,
            value: action.payload.cardId,
          }),
        }
      } : state
    case ADD_ARRAY: {
      if (!state[action.payload.boardId]) return state

      const newState = {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          ids: [ ...state[action.payload.boardId].ids ],
        }
      }
      action.payload.array.forEach(id => {
        newState[action.payload.boardId].ids = addUniqueValueToArray({
          array: newState[action.payload.boardId].ids,
          value: id
        })
      })
      return newState
    }
    case REMOVE: {
      if (!state[action.payload.boardId]) return state

      const newState = {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          ids: [ ...state[action.payload.boardId].ids.filter(id => id !== action.payload.id) ],
        }
      }

      return newState
    }
    case SET_LOAD_STATUS:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          isLoading: action.payload.isLoading,
          isLoaded: action.payload.isLoaded,
        }
      } : state
    case SET_CURSOR:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          cursor: action.payload.cursor,
        }
      } : state
    default: return state
  }
}

export function add ({ boardId, cardId }) {
  return {
    type: ADD,
    payload: {
      boardId,
      cardId,
    }
  }
}

export function addArray ({ boardId, array }) {
  return {
    type: ADD_ARRAY,
    payload: {
      boardId,
      array,
    }
  }
}

export function remove ({ boardId, id }) {
  return {
    type: REMOVE,
    payload: {
      boardId,
      id,
    }
  }
}

export function setLoadStatus ({ boardId, isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      boardId,
      isLoading,
      isLoaded
    }
  }
}

export function setCursor ({ boardId, cursor }) {
  return {
    type: SET_CURSOR,
    payload: {
      boardId,
      cursor,
    }
  }
}
